export const setPlacesFailed = ({ reason }) => state => {
  return {
    ...state,
    places: {
      ...state.places,
      lastFetch: {
        failed: true,
        lastFailure: Date.now(),
        reason,
      },
      loadingPlaces: false,
    },
  };
};
